import {IconSeparatorHorizontal} from "@tabler/icons-react";
import {useTranslation} from "react-i18next";
import {getOtsActionButtonClassName} from "../components/OtsButton";
import {OtsPopover} from "../components/OtsPopover";
import {OtsRadioGroup} from "../components/OtsRadioGroup";
import {OtsThemeRoot} from "../theme/OtsTheme";

export type DataGridSeparatorPickerProps<T extends string> = {
  mode: T;
  options: readonly {value: T; label: string}[];
  onChange: (mode: T) => void;
};

/** Radio settings stay open for arrow-key selection and close with Escape or an outside click. */
export function DataGridSeparatorPicker<T extends string>({mode, options, onChange}: DataGridSeparatorPickerProps<T>) {
  const {t} = useTranslation("common");
  return (
    <OtsThemeRoot className="inline-flex">
      <OtsPopover
        density="compact"
        placement="bottom end"
        ariaLabel={t("grid.separators", "Separators")}
        tooltip={t("grid.separators", "Separators")}
        pressed={mode !== "NONE"}
        trigger={<IconSeparatorHorizontal aria-hidden="true" className="size-[18px]" />}
        buttonClassName={getOtsActionButtonClassName(
          "text",
          "compact",
          [
            "!size-8 !p-0",
            mode !== "NONE"
              ? "!border-transparent !bg-[var(--ots-service-work)] !text-[var(--ots-on-service-work)] hover:brightness-95"
              : "",
          ].join(" ")
        )}
        panelClassName="w-60"
      >
        <OtsRadioGroup
          size="compact"
          ariaLabel={t("grid.separatorChoices", "Separator choices")}
          options={options.map((option) => ({
            value: option.value,
            label: t(`grid.separator.${option.value}`, option.label),
          }))}
          value={mode}
          onChange={onChange}
        />
      </OtsPopover>
    </OtsThemeRoot>
  );
}
